import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import imagenesEditProject from "../assets/imgEditProject/imgEditProject";
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { formatDate } from '../components/Utils/Utils.js';

function InformacionPlaza() {
    const { id } = useParams();
    const MySwal = withReactContent(Swal);
    const navigate = useNavigate();
    const cookies = new Cookies();
    const getSesion = cookies.get("Bearer");
    const [isLoading, setIsLoading] = useState(true);
    const [disableButton, setDisableButton] = useState(false);

    // Constants for job types
    const jobTypes = ["", "Fija", "Temporal"];
    const contractTypes = ["", "Tiempo completo", "Tiempo parcial"];
    const scheduleTypes = ["", "Fijo", "Rotativo"];
    const workModalities = ["", "Presencial", "Remoto", "Híbrido"];

    const initialStateJob = {
        application_deadline: "",
        created_at: "",
        description: "",
        end_date: "",
        id: "",
        id_company: "",
        id_type_contract: "",
        id_type_job_vacancy: "",
        id_type_opportunities: "",
        id_type_schedule: "",
        id_work_modality: "",
        job_title: "",
        location: "",
        salary: "",
        schedules: "",
        start_date: "",
        status: "",
        updated_at: "",
    };

    const [job, setJob] = useState(initialStateJob);

    // Helper functions
    const getJobType = (id) => jobTypes[id] || "No especificado";
    const getContractType = (id) => contractTypes[id] || "No especificado";
    const getScheduleType = (id) => scheduleTypes[id] || "No especificado";
    const getWorkModality = (id) => workModalities[id] || "No especificado";

    const applyJob = () => {
        MySwal.fire({
            title: "¿Está seguro?",
            text: "Sí, deseo enviar mi perfil para esta plaza de trabajo",
            color: "#fff",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Enviar",
            cancelButtonText: "Cancelar",
            background: '#1a365d'
        }).then((result) => {
            if (result.isConfirmed) sendApplication();
        });
    };

    const sendApplication = async () => {
        setDisableButton(true);
        try {
            const url = `${process.env.REACT_APP_API_URI}freelancer/apply-project/${getSesion.id}`;
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json',
                    'ApiToken': `Bearer ${getSesion.token}`
                }
            };

            const applicationData = {
                budget: "",
                id_type_opportunities: 2,
                project_id: id,
                project_proposal: "",
            };

            await axios.post(url, applicationData, config);

            MySwal.fire({
                title: "¡Completado!",
                text: "Tu perfil ha sido enviado con éxito! En los próximos días recibirás una notificación sobre el proceso a través de tu correo electrónico.",
                color: "#fff",
                icon: "success",
                background: '#1a365d'
            });

            setTimeout(() => navigate('/perfil-freelancer'), 3000);
        } catch (err) {
            MySwal.fire({
                position: 'center',
                icon: 'warning',
                title: err.response?.data?.message || 'Error al enviar la solicitud',
                showConfirmButton: false,
                timer: 3500,
                background: '#1a365d'
            });
        }
        disableButton(false);
    };

    const fetchJob = async () => {
        setIsLoading(true);
        try {
            const url = `${process.env.REACT_APP_API_URI}project/get/${id}?id_type_opportunities=2`;
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'ApiToken': `Bearer ${getSesion.token}`
                }
            };

            const response = await axios.get(url, config);
            setJob(response.data);
        } catch (err) {
            console.error(err);
            MySwal.fire({
                title: 'Error',
                text: 'No se pudo cargar la información de la plaza',
                icon: 'error',
                background: '#1a365d'
            });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchJob();
    }, [id]);

    if (isLoading) {
        return (
            <div className="min-h-screen bg-gradient-to-b from-Light-purple via-turquoise to-Dark-purple flex items-center justify-center">
                <div className="text-white text-2xl">Cargando...</div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-b from-Light-purple via-turquoise to-Dark-purple py-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-6xl mx-auto">
                {/* Header with back button */}
                <div className="flex items-center mb-8">
                    <button
                        onClick={() => navigate(-1)}
                        className="mr-4 p-2 rounded-full hover:bg-blue-700 transition-colors"
                    >
                        <img
                            src={imagenesEditProject.arrow_back_4}
                            className="w-8 h-8"
                            alt="Volver"
                        />
                    </button>
                    <h1 className="text-Yellow text-3xl font-bold">Plaza de trabajo</h1>
                </div>

                {/* Job title */}
                <h1 className="text-white text-2xl sm:text-3xl md:text-4xl font-bold mb-6">
                    {job.job_title}
                </h1>

                {/* Job description */}
                <div className="bg-blue-900 bg-opacity-30 rounded-lg p-6 mb-8">
                    <p className="text-white text-lg leading-relaxed whitespace-pre-line">
                        {job.description}
                    </p>
                </div>

                {/* Job details grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                    {/* Left column */}
                    <div className="space-y-6">
                        <div className="bg-blue-900 bg-opacity-30 rounded-lg p-6">
                            <h2 className="text-Yellow text-xl font-semibold mb-4">Detalles de la plaza</h2>

                            <div className="space-y-4">
                                <div>
                                    <h3 className="text-Yellow text-lg">Modalidad</h3>
                                    <p className="text-white">
                                        {getWorkModality(job.id_work_modality)}
                                    </p>
                                </div>
                                
                                <div>
                                    <h3 className="text-Yellow text-lg">Tipo de plaza</h3>
                                    <p className="text-white">
                                        {getJobType(job.id_type_job_vacancy)}
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-Yellow text-lg">Tipo de contrato</h3>
                                    <p className="text-white">
                                        {getContractType(job.id_type_contract)}
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-Yellow text-lg">Tipo de horario</h3>
                                    <p className="text-white">
                                        {getScheduleType(job.id_type_schedule)}
                                    </p>
                                </div>

                                {job.id_type_schedule === "1" && (
                                    <div>
                                        <h3 className="text-Yellow text-lg">Horario de trabajo</h3>
                                        <p className="text-white">
                                            {job.schedules || 'No especificado'}
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Right column */}
                    <div className="space-y-6">
                        <div className="bg-blue-900 bg-opacity-30 rounded-lg p-6">
                            <h2 className="text-Yellow text-xl font-semibold mb-4">Información adicional</h2>

                            <div className="space-y-4">

                                {(job.id_work_modality === "1" || job.id_work_modality === "3") && (
                                    <div>
                                        <h3 className="text-Yellow text-lg">Ubicación</h3>
                                        <p className="text-white">
                                            {job.location || 'No especificada'}
                                        </p>
                                    </div>
                                )}

                                <div>
                                    <h3 className="text-Yellow text-lg">Salario</h3>
                                    <p className="text-white">
                                        {`$ ${job.salary}` || 'No especificado'}
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-Yellow text-lg">Fecha de inicio</h3>
                                    <p className="text-white">{job.start_date ? formatDate(job.start_date) : 'No definido'}</p>
                                </div>

                                <div>
                                    <h3 className="text-Yellow text-lg">Fecha de finalización</h3>
                                    <p className="text-white">{job.end_date ? formatDate(job.end_date) : 'No definido'}</p>
                                </div>

                                <div>
                                    <h3 className="text-Yellow text-lg">Fecha límite de aplicación</h3>
                                    <p className="text-white">{job.application_deadline ? formatDate(job.application_deadline) : 'No definido'}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Apply button */}
                <div className="text-center">
                    <button
                        onClick={applyJob}
                        className="bg-Yellow hover:bg-yellow-600 text-white font-bold py-3 px-8 rounded-lg text-lg transition-colors duration-300"
                        disabled={disableButton}
                    >
                        Enviar mi perfil
                    </button>
                </div>
            </div>
        </div>
    );
}

export default InformacionPlaza;